<template>
    <div class="view pa24">
        <commonTable :tableData="tableData" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange">
            <template v-slot:table>
                <el-table-column prop="username" align="center" label="操作人" />
                <el-table-column prop="description" align="center" label="操作行为" />
                <el-table-column prop="time" align="center" label="访问时长" />
                <el-table-column prop="deviceName" align="center" label="设备名称" />
                <el-table-column prop="requestIp" align="center" label="ip" />
                <el-table-column prop="createTime" align="center" label="创建时间" />
            </template>
        </commonTable>
    </div>
</template>

<script>
    import commonTable from "@/components/common/commonTable";
    import { log } from '@/api/gps.js'

    export default {
        name: "deviceLog",
        components: {
            commonTable
        },
        data() {
            return {
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
            };
        },
        created() {
            this.getList()
        },
        methods: {
            handleSizeChange(num) {
                this.pageSize = num;
                this.pageNum = 1;
                this.getList();
            },
            handleCurrentChange(num) {
                this.pageNum = num;
                this.getList();
            },
            getList() {
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
                log(params).then(res => {
                    this.tableData = res.data.list
                    this.total = res.data.total
                })
            },

        }
    }
</script>

<style lang="scss" scoped></style>